import React from "react";
import { FormControl, ControlLabel, Alert } from "react-bootstrap";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import TCDurationForm from "./tc-entry-duration/tc-duration-form.jsx";
import TCButtonPanel from "./shared/tc-button-panel.jsx";
import moment from "moment";
import immutable from "immutable";
import { browserHistory } from "react-router";

export default class DurationTC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            offSysId: null,
            peopleId: null,
            assignId: null,
            weekEndings: [],
            selectedWeekEnding: null,
            selectedTimecardId: null,
            hideButtonPanel: true,
            buttons: "",
            errors: []
        }
        this.role = context.getRouteParam(this, "role");

        this.onSelectedWeekEndingChanged = this.onSelectedWeekEndingChanged.bind(this);
        this.onNewTimecardAdded = this.onNewTimecardAdded.bind(this);
        this.onSubmitTimecard = this.onSubmitTimecard.bind(this);
        this.onDeleteTimecard = this.onDeleteTimecard.bind(this);
        this.onRecallTimecard = this.onRecallTimecard.bind(this);
        this.onLoadTimecardCompleted = this.onLoadTimecardCompleted.bind(this);
        this.onSupplementTimecard = this.onSupplementTimecard.bind(this);
        this.deleteTimecard = this.deleteTimecard.bind(this);
    }

    onSelectedWeekEndingChanged(newValue) {
        console.log(newValue);
        let clone = immutable.fromJS(this.state).toJS();
        clone.selectedTimecardId = newValue;
        clone.selectedWeekEnding = this.getWeekEndingById(clone.weekEndings, newValue);
        this.setState(clone);
    }

    onNewTimecardAdded(newTimecardId) {
        let self = this;
        ajax.vm()
            .get('people/tc-duration')
            .then(function (res) {
                let data = res.data;
                data.selectedTimecardId = newTimecardId;
                data.selectedWeekEnding = self.getWeekEndingById(data.weekEndings, newTimecardId);
                self.setState(res.data);
            });
    }

    onSupplementTimecard() {
        let clone = immutable.fromJS(this.state).toJS();
        clone.weekEndings[0].timecardId = -1;
        clone.selectedTimecardId = -1;
        clone.selectedWeekEnding = clone.weekEndings[0].weekEnding;
        this.setState(clone);
        let self = this;
    }

    onSubmitTimecard() {
        const self = this;
        const timecardId = this.state.selectedTimecardId;
        let vm = this.state;
        let newNotes = this.refs.durationForm.refs.tcSummary.getNotes().trim();
        context.message({
            show: true,
            type: "loading",
            message: "Preparing to submit timecard..."
        });
        ajax.api()
            .put(`add-notes/${timecardId}`, { role: self.role, notes: newNotes })
            .then(function (res) {
                ajax.api()
                    .get(`prepare-timecard-submission/${timecardId}`)
                    .then(function (res) {
                        
                        if (res.data.errorMessages != null && res.data.errorMessages.length > 0) {
                            self.handleError(res.data.errorMessages, function () {
                                context.message({ show: false });
                            });
                        } else {
                            const submitToken = res.data.token
                            browserHistory.push(context.routeUrl(`people/tc-submit/${submitToken.timecardId}/${escape(submitToken.token)}`));
                            context.message({ show: false });
                        }
                    })
                    .catch(function(err) {
                        let errors = [];
                        let data = err.response.data;
                        if(data.exceptionMessage.length > 1 || data.message.length > 1) {
                            errors.push(data.exceptionMessage || data.message);
                        } else {
                            for(let k in data.data) {
                                errors.push(data.data[k]);
                            }
                        }

                        self.handleError(errors, function () {
                            context.message({ show: false });
                        });
                    });
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error when attempting to add notes.<br />{msg}</div>,
                    buttons: "close"
                });
            });
    }

    onRecallTimecard() {
        let self = this;
        let newNotes = this.refs.durationForm.refs.tcSummary.getNotes().trim();
        if (newNotes == null || newNotes.length < 1) {
            context.message({
                show: true,
                type: "error",
                message: <div>Notes is required</div>,
                buttons: "ok"
            });
            return false;
        }

        context.message({
            show: true,
            type: "info",
            message: "Are you sure you want to recall this timecard?",
            buttons: "yes,no"
        }, function (button, s) {
            // s is timecardId, timecardId is set as the 3rd parameter of context.message
            if (button === "yes") {
                ajax.api()
                    .put("recall-timecard/" + s, { role: self.role, notes: newNotes })
                    .then(function (res) {
                        window.location = context.routeUrl(`${self.role}/tc-entry-duration/${s}`);
                    })
                    .catch(function (err) {
                        const data = err.response.data;
                        const msg = data.exceptionMessage || data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: <div>Error while recalling timecard.<br />{msg}</div>,
                            buttons: "ok"
                        });
                    });
            }
        }, self.state.selectedTimecardId);
    }

    onDeleteTimecard() {
        let vm = this.state;
        const self = this;
        ajax.api()
            .get("timecard-has-unapproved-pto/" + vm.selectedTimecardId)
            .then(function (res) {

                let title = "";
                let msg = "Are you sure you want to delete this timecard?";
                let buttons = "yes,no";
                let type = "info";

                if (res.data) {
                    title = <span className="ap-pto-dialog-title"><i className="fa fa-calendar-o" /> Cancel Time-Off</span>;
                    msg = <div className="ap-mb-2"><b>This will cancel your Time-Off request.<br/>Are you sure you want to continue?</b></div>;
                    buttons = "continue,cancel";
                    type = "";
                }

                context.message({
                    show: true,
                    type: type,
                    title: title,
                    message: msg,
                    buttons: buttons
                }, function (button, s) {
                    // s is timecardId, timecardId is set as the 3rd parameter of context.message
                    if (button === "yes" || button === "continue") {
                        self.deleteTimecard(s)
                    }
                }, vm.selectedTimecardId);
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error while deleting timecard.<br />{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    deleteTimecard(timecardId) {
        const self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Deleting Timecard. Please wait..."
        });
        ajax.api()
            .delete("delete-timecard/" + timecardId)
            .then(function (res) {
                window.location = context.routeUrl('people/tc-entry/');
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error while deleting timecard.<br />{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    onLoadTimecardCompleted(tc, errors) {
        const clone = immutable.fromJS(this.state).toJS();
        const buttonConfig = this.prepareButtonPanel(tc);
        clone.timecard = tc;
        clone.hideButtonPanel = buttonConfig.hideButtonPanel;
        clone.buttons = buttonConfig.buttons;
        clone.errors = (errors == null)? []: errors;
        this.setState(clone);
    }

    prepareButtonPanel(tc) {
        const result = {
            hideButtonPanel: true,
            buttons: ""
        };
        if (tc) {
            if (tc.statusCode && tc.statusCode.toLowerCase() === "saved") {
                result.hideButtonPanel = false;
                result.buttons = "submit,delete";
            }
        }

        return result;
    }

    componentDidMount() {
        let self = this;

        let tid = this.props.location.query.tid; // from tc-entry.jsx
        if (!tid && this.props.routeParams)
            tid = this.props.routeParams["timecardId"]; // from route: people/tc-entry-duration/{timecardId}

        ajax.vm()
            .get('people/tc-duration')
            .then(function (res) {
                const data = res.data;
                if (tid) {
                    data.selectedTimecardId = tid;
                    data.selectedWeekEnding = self.getWeekEndingById(data.weekEndings, tid);
                }
                self.setState(data);
            });
    }

    getWeekEndingById(weekEndings, tid) {
        for (let i = 0; i < weekEndings.length; i++) {
            if (weekEndings[i].timecardId == tid) {
                return weekEndings[i].weekEnding;
            }
        }
    }

    handleError(errors, callback) {
        const clone = immutable.fromJS(this.state).toJS();
        if ((typeof (errors)).toLowerCase() === "string") clone.errors = [errors];
        else clone.errors = errors;
        this.scrollTop = true;
        this.setState(clone, function () {
            if (callback) callback();
        });
    }

    render() {
        let allowEdit = true;
        let vm = this.state;
        let alert = null;
        let timecardStatus = vm.timecard ? vm.timecard.statusCode.toLowerCase() : null;

        if (timecardStatus != null && timecardStatus !== "saved") {
            allowEdit = false;
            alert = <Alert bsStyle="danger">
                Timecard for the weekend {moment(vm.timecard.weekEnding).format("MM/DD/YYYY")} has been {vm.timecard.statusCode} already!&nbsp;
                        {timecardStatus !== "submitted" ?
                    <a href="#" onClick={this.onSupplementTimecard} style={{ color: "#809561" }}>
                        Please click this link to create new timecard for this weekend {moment(vm.timecard.weekEnding).format("MM/DD/YYYY")}.
                            </a>
                    : ""}
            </Alert>;

        } else if (vm.errors.length > 0) {
            alert = <Alert bsStyle="danger"><ul>
                {
                    vm.errors.map(err => <li key={err}>{err}</li>)
                }
            </ul></Alert>;
        }
        return (
            <div className="ap-form-container">
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 col-xs-12 col-sm-12 text-center">
                            <ControlLabel>This timecard is for the week-ending</ControlLabel>
                            <FormControl componentClass="select" value={vm.selectedTimecardId || ''}
                                onChange={(evt) => this.onSelectedWeekEndingChanged(evt.target.value)}>
                                {vm.weekEndings.map(we => <option key={we.timecardId} value={we.timecardId}>{moment(we.weekEnding).format("MM/DD/YYYY")}</option>)}
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {alert}
                        </div>
                    </div>
                </div>

                <TCDurationForm peopleId={vm.peopleId} assignId={vm.assignId} offSysId={vm.offSysId} timecardId={vm.selectedTimecardId}
                    route={this.props.route} allowEdit={allowEdit} hideGrid={false} weekEnding={vm.selectedWeekEnding} ref="durationForm"
                    onNewTimecardAdded={this.onNewTimecardAdded} role={this.role}
                    onLoadTimecardCompleted={this.onLoadTimecardCompleted} clockeditTcRoute={this.props.clockeditTcRoute}/>

                <TCButtonPanel buttons={vm.buttons}
                    hidden={vm.hideButtonPanel}
                    onSubmit={this.onSubmitTimecard}
                    onDelete={this.onDeleteTimecard}
                    onRecall={this.onRecallTimecard}
                    onClose={() => {
                        window.location = context.routeUrl("home");
                    }} />
            </div>
        );
    }
}